import { TextField } from "@mui/material";
import { useContext } from "react";

import Context from "../../../context";
import { UnknownFund } from "../../../types";

export default function TaxExempt({ spanishTaxExempt, id }: UnknownFund) {
	const { actions, state } = useContext(Context);

	const onChange = (value: string) => {
		actions.setData(
			state.data.map((item) =>
				item.id === id ? { ...item, spanishTaxExempt: value === "Si" } : item
			)
		);
	};

	return (
		<TextField
			SelectProps={{ native: true }}
			fullWidth
			label='Exento de impuestos'
			onChange={(e) => onChange(e.target.value)}
			select
			size='small'
			sx={{ width: 183 }}
			value={spanishTaxExempt === null ? "" : spanishTaxExempt ? "Si" : "No"}
		>
			{["", "Si", "No"].map((option, index) => (
				<option key={index} value={option}>
					{option}
				</option>
			))}
		</TextField>
	);
}
